import { IRtcStream } from "@formant/core/model/IRtcStream";

import { IRtcStreamMessage } from "../models/IRtcStreamMessage";
import { IRtcStreamPayload } from "../models/IRtcStreamPayload";

export function createRtcStreamMessage(
    stream: IRtcStream,
    payload: IRtcStreamPayload,
    frameId?: string,
): IRtcStreamMessage {
    return {
        header: {
            stream,
            created: Date.now(),
            frameId: frameId || "",
        },
        payload,
    };
}
